import React from 'react';
import PropTypes from 'prop-types';

import { Button, Grid, Tooltip } from '@mui/material';
import { Cached, Clear } from '@mui/icons-material';
import { withTheme } from '@mui/styles';

import CompactTextField from './CompactTextField';

class TokenControl extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			client_id: '',
			client_secret: '',
		};

		this.onGetToken = props.onGetToken;
		this.onRefreshToken = props.onRefreshToken;
		this.onInvalidate = props.onInvalidate;

		this.onAccessTokenChanged = props.onAccessTokenChanged;
		this.onRefreshTokenChanged = props.onRefreshTokenChanged;
	}

	valueChanged(name) {
		return (event) => {
			this.setState({ [name]: event.target.value });
		};
	}

	getToken() {
		this.onGetToken('client_credentials', this.state.client_id, this.state.client_secret);
	}

	renderTab(type) {
		return (
			<React.Fragment>
				<CompactTextField
					type="text"
					value={this.state.client_id}
					onChange={this.valueChanged('client_id')}
					id="client-id-field"
					label="Client ID"
				/>
				<CompactTextField
					type="text"
					value={this.state.client_secret}
					onChange={this.valueChanged('client_secret')}
					id="client-secret-field"
					label="Client Secret"
					onKeyDown={(e) => {
						if (e.keyCode === 13) { // enter
							this.getToken();
						}
					}}
				/>
				<Button variant="contained" color="primary" style={{ marginTop: 8 }}
					onClick={() => {
						this.getToken();
					}}
				>
					Authorize
				</Button>
			</React.Fragment>
		);
	}

	render() {
		let accessToken = this.props.access_token || '';
		let refreshToken = this.props.refresh_token || '';
		return (
			<div style={{ display: 'flex', flexFlow: 'column', height: '100%', overflow: 'hidden', background: this.props.theme.palette.background.paper }}>
				<div style={{ overflow: 'auto', flex: '1 1 auto' }}>
					<Grid container direction="column" justifyContent="center" alignItems="stretch" style={{ padding: '8px', borderBottom: this.props.theme.border }}>
						<Grid container item direction="row" alignItems="center" spacing={2}>
							<Grid item xs>
								<CompactTextField
									type="text"
									value={accessToken}
									onChange={(event) => this.onAccessTokenChanged(event.target.value)}
									id="access-token-field"
									label="Access Token"
									readOnly
								/>
							</Grid>
							<Grid item style={{ marginTop: 8 }}>
								<Tooltip title="Invalidate">
									<Clear className="icon-button" cursor="pointer" onClick={this.onInvalidate} />
								</Tooltip>
							</Grid>
						</Grid>
						<Grid container item direction="row" alignItems="center" spacing={2}>
							<Grid item xs>
								<CompactTextField
									type="text"
									value={refreshToken}
									onChange={(event) => this.onRefreshTokenChanged(event.target.value)}
									id="refresh-token-field"
									label="Refresh Token"
									readOnly
								/>
							</Grid>
							<Grid item style={{ marginTop: 8 }}><Tooltip title="Refresh Token"><Cached className="icon-button" cursor="pointer" onClick={this.onRefreshToken} /></Tooltip></Grid>
						</Grid>
					</Grid>
					<div style={{ padding: 8, }}>{this.renderTab('client_credentials')}</div>
				</div>
			</div>
		);
	}
}

export default withTheme(TokenControl);

TokenControl.propTypes = {
	access_token: PropTypes.string,
	refresh_token: PropTypes.string,
	serverUrl: PropTypes.string,

	onGetToken: PropTypes.func,
	onRefreshToken: PropTypes.func,
	onInvalidate: PropTypes.func,
	onAccessTokenChanged: PropTypes.func,
	onRefreshTokenChanged: PropTypes.func,

	theme: PropTypes.object,
};
